import CommonDelete from "@/components/common/Delete";
import { singleProp } from "@/interface/dataInterface";
import { FC } from "react";

const ReservationDelete: FC<singleProp> = ({prop}) => (
    <CommonDelete id={prop} resource="auto-service-reservation"/>
)

export default ReservationDelete